import axios from '../../../configs/axios';

export default {
  fetchCustomReports(filters, searchParams = '') {
    return axios.get(`/custom_reports.json${searchParams}`, {
      params: {
        request: {
          assets: {
            custom_reports: {
              filters,
              assets: 'reports_list',
            },
          },
        },
      },
    });
  },
  fetchVersionData(filters, searchParams = '') {
    return axios.get(`/custom_reports.json${searchParams}`, {
      params: {
        request: {
          assets: {
            custom_reports_versions: {
              assets: ['versions_history'],
              filters,
            },
          },
        },
      },
    });
  },
  subscribe(reportId) {
    return axios.post(`/custom_reports/${reportId}/create_recipient`, {});
  },
  unsubscribe(reportId) {
    return axios.delete(`/custom_reports/${reportId}/delete_recipient`);
  },
  updatePerPage(perPage) {
    return axios.post('/profile/update_options', { page_name: 'custom_reports', options: { per_page: perPage } });
  },
};
